import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = {
    class: "text-xl font-semibold text-gray-900 dark:text-white",
    "data-testid": "modal-title"
};
const _hoisted_3 = { class: "text-base leading-relaxed text-gray-500 dark:text-gray-400" };
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Button, Modal } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountStatusIcon',
    setup(__props) {
        const router = useRouter();
        // Component state
        const isModalOpen = ref(false);
        // Event handlers
        const handleIconClick = () => {
            isModalOpen.value = true;
        };
        const closeModal = () => {
            isModalOpen.value = false;
        };
        const confirmNavigation = async () => {
            isModalOpen.value = false;
            await router.push("/onboarding");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Button), {
                    variant: "secondary",
                    "icon-left": "ri-error-warning-line",
                    label: _ctx.$t('accountStatus.onboarding'),
                    "aria-label": _ctx.$t('accountStatus.onboardingIncomplete'),
                    title: _ctx.$t('accountStatus.tooltip'),
                    "data-testid": "account-status-warning-icon",
                    class: "text-red-700 dark:text-red-300",
                    onClick: handleIconClick
                }, null, 8 /* PROPS */, ["label", "aria-label", "title"]),
                _createVNode(_unref(Modal), {
                    modelValue: isModalOpen.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isModalOpen).value = $event)),
                    size: "md",
                    "data-testid": "account-status-modal",
                    dismissable: true,
                    "close-on-escape": true,
                    onClose: closeModal
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("accountStatus.modal.title")), 1 /* TEXT */)
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('accountStatus.modal.cancel'),
                            "data-testid": "cancel-modal-btn",
                            onClick: closeModal
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(Button), {
                            variant: "primary",
                            label: _ctx.$t('accountStatus.modal.confirm'),
                            "data-testid": "confirm-modal-btn",
                            onClick: confirmNavigation
                        }, null, 8 /* PROPS */, ["label"])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("accountStatus.modal.message")), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]));
        };
    }
});
